import { render, staticRenderFns } from "./App.vue?vue&type=template&id=21709388"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "@riseupil/base-ui/src/scss/fonts.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./App.vue?vue&type=style&index=1&id=21709388&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports